/**
 * 🌌 SPACE PARTICLES - Particules spatiales flottantes
 * Background animé réutilisable
 */

import React from 'react';
import { motion } from 'framer-motion';

const SpaceParticles = ({ count = 40, className = '' }) => {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {[...Array(count)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full"
          style={{
            width: (i % 4) + 2,
            height: (i % 4) + 2,
            left: `${(i * 2.5) % 100}%`,
            top: `${(i * 3.7) % 100}%`,
            background: i % 3 === 0 
              ? 'rgba(0, 255, 255, 0.8)' 
              : i % 3 === 1 
                ? 'rgba(255, 0, 255, 0.8)' 
                : 'rgba(255, 255, 255, 0.6)',
            boxShadow: i % 3 === 0 
              ? '0 0 10px rgba(0, 255, 255, 0.8)' 
              : i % 3 === 1 
                ? '0 0 10px rgba(255, 0, 255, 0.8)' 
                : '0 0 5px rgba(255, 255, 255, 0.5)',
          }}
          animate={{
            y: [0, -30 - (i % 20), 0],
            x: [0, (i % 2 === 0 ? 15 : -15), 0],
            opacity: [0.3, 1, 0.3],
            scale: [1, 1.5, 1],
          }}
          transition={{
            duration: 3 + (i % 4),
            repeat: Infinity,
            delay: (i % 5) * 0.5,
            ease: "easeInOut"
          }}
        />
      ))}
    </div>
  );
};

/**
 * 🔮 GLOW CIRCLES - Cercles lumineux de fond
 */
const GlowCircles = ({ className = '' }) => {
  return (
    <div className={`absolute inset-0 pointer-events-none ${className}`}>
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-purple-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-pink-500/10 rounded-full blur-3xl" />
    </div>
  );
};

/**
 * 🌟 SHIMMER EFFECT - Effet de brillance qui traverse
 */
const ShimmerEffect = ({ className = '' }) => {
  return (
    <motion.div
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{
        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)',
      }}
      animate={{
        x: ['-100%', '200%']
      }}
      transition={{
        duration: 3,
        repeat: Infinity,
        repeatDelay: 2
      }}
    />
  );
};

/**
 * ✨ SPARKLES BACKGROUND - Étoiles scintillantes
 */
const SparklesBackground = ({ isDarkMode = true }) => {
  const sparkles = ['✨', '💜', '⭐', '💫', '🌟'];
  
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {[...Array(5)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute text-xl"
          style={{
            left: `${10 + i * 20}%`,
            top: `${20 + (i % 2) * 40}%`,
          }}
          animate={{
            y: [0, -8, 0],
            opacity: [0.3, 0.8, 0.3],
            scale: [1, 1.3, 1],
            rotate: [0, 10, -10, 0]
          }}
          transition={{
            duration: 2 + i * 0.5,
            delay: i * 0.3,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          {sparkles[i]}
        </motion.div>
      ))}
    </div>
  );
};

export { SpaceParticles, GlowCircles, ShimmerEffect, SparklesBackground };
export default SpaceParticles;
